<div>
  <app-page>
    <div class="top-cta">
      <dx-button
        [text]="'COMMON.BACK' | translate"
        icon="back"
        type="default"
        class="integration-btn"
        (click)="navigateBack()"
      >
      </dx-button>
      <dx-button
        class="cta-btn"
        type="normal"
        text="{{ 'COMMON.SAVE' | translate }}"
        (click)="submit()"
      ></dx-button>
    </div>
    <app-page-title
      [title]="
        editingMode
          ? ('ADMINISTRATION.CATEGORY-TITLE-EDIT' | translate)
          : ('ADMINISTRATION.CATEGORY-TITLE-ADD' | translate)
      "
    ></app-page-title>
    <div class="row">
      <div class="col-md-12 col-lg-5">
        <app-panel class="image-panel">
          <div id="avatar-upload" class="uploader-container">
            <img
              class="category-image"
              [src]="formData.image"
              *ngIf="formData.image"
            />
            <img
              class="category-image"
              src=""
              appTrainingImageFallback
              *ngIf="!formData.image && editingMode"
            />
            <div
              class="uploader-preview-container"
              *ngIf="!formData.image && !editingMode"
            >
              <img src="assets/img/upload.jpg" />
              <span class="preview-title">{{
                "COMMON.UPLOAD-IMAGE" | translate
              }}</span>
              <span class="preview-description">{{
                "COMMON.UPLOAD-IMAGE-SIZE" | translate
              }}</span>
            </div>
          </div>
          <dx-file-uploader
            #fileUploader
            dialogTrigger="#avatar-upload"
            dropZone="#avatar-upload"
            [multiple]="false"
            [allowedFileExtensions]="['.jpg', '.jpeg', '.gif', '.png']"
            uploadMode="useForm"
            [visible]="false"
            (valueChange)="onCategoryImageSelected($event)"
          ></dx-file-uploader>
        </app-panel>
      </div>
      <div class="col-md-12 col-lg-7">
        <app-panel
          class="training-category-panel"
          [title]="'ADMINISTRATION.TITLE-DESCRIPTION' | translate"
        >
          <dx-form #form labelMode="floating" [formData]="formData">
            <dxi-item>
              <div *dxTemplate>
                <div
                  class="standard-category-picker"
                  (click)="openStandardCategoryModal()"
                >
                  <div class="standard-category-picker-icon">
                    <i
                      class="dx-icon dx-svg-icon"
                      [innerHTML]="getStandardCategoryIcon()"
                    ></i>
                  </div>

                  <div class="standard-category-picker-content">
                    <div class="standard-category-picker-title">
                      {{ 
                        selectedStandardCategory?.name
                          || ('STANDARD-CATEGORIES.SELECT-STANDARD-CATEGORY' | translate)  
                      }}
                    </div>
                    <div class="standard-category-picker-subtitle">
                      @if(selectedStandardCategory) {
                        <span class="badge-dot"></span>
                        {{ getStandardCategoryPath(selectedStandardCategory) }}
                      } @else {
                        {{ 'STANDARD-CATEGORIES.PREFILLS-STANDARD-CATEGORY-1' | translate }}
                      }
                    </div>
                  </div>

                  <div class="standard-category-picker-actions">
                    <dx-button
                      *ngIf="selectedStandardCategory"
                      icon="clear"
                      stylingMode="text"
                      (onClick)="clearStandardCategory($event)"
                    ></dx-button>
                    <i class="dx-icon dx-icon-chevronnext standard-category-picker-chevron"></i>
                  </div>
                </div>
              </div>
            </dxi-item>
            @if (!formData.standardTrainingCategoryId) {
              <dxi-item dataField="name">
                <dxo-label
                  [text]="'COMMON.FIELDS.NAME' | translate">
                </dxo-label>
                <dxi-validation-rule
                  type="required"
                  [message]="'VALIDATIONS.NAME-REQUIRED' | translate">
                </dxi-validation-rule>
              </dxi-item>
            } @else {
              <dxi-item>
                <div *dxTemplate>
                  <div class="training-category-name-field">
                    <div class="training-category-name-label training-category-name-label-standard">
                      <span class="dx-field-item-label-text training-category-name-label-text">
                        {{ 'COMMON.FIELDS.NAME' | translate }}
                      </span>

                      <span class="category-origin-badge category-origin-badge-standard">
                        <i
                          class="dx-icon dx-svg-icon"
                          [innerHTML]="getLockIcon()">
                        </i>
                        {{ 'ADMINISTRATION.TRAINING-CATEGORY.TRAINING-CATEGORY-TYPE.STANDARD' | translate }}
                      </span>
                    </div>

                    <dx-text-box
                      [value]="formData.name"
                      [readOnly]="true"
                    ></dx-text-box>
                  </div>
                </div>

                <dxi-validation-rule
                  type="required"
                  [message]="'VALIDATIONS.NAME-REQUIRED' | translate">
                </dxi-validation-rule>
              </dxi-item>
            }
            <dxi-item
              dataField="description"
              editorType="dxTextArea"
              [editorOptions]="{
                height: 145
              }"
            >
              <dxo-label
                [text]="'COMMON.FIELDS.DESCRIPTION' | translate"
              ></dxo-label>
            </dxi-item>
            <dxi-item>
              <div *dxTemplate>
                <div class="subscription-automation-section">
                  <div class="subscription-automation-section-header">
                    <span class="subscription-automation-section-label">
                      {{ 'ADMINISTRATION.TRAINING-CATEGORY.ASSOCIATED-TRAINING-GROUPS' | translate }}
                    </span>

                    <span class="subscription-automation-badge">
                      <span 
                        class="badge-dot"
                        [class.active]="hasAutomationConfiguration"
                      ></span>
                      {{ 'ADMINISTRATION.TRAINING-CATEGORY.AUTOMATES-SUBSCRIPTION-SETTINGS' | translate }}
                    </span>
                  </div>

                  <div class="associated-training-groups-container">
                    <dx-drop-down-box
                      [(value)]="formData.associatedTrainingGroupIds"
                      [inputAttr]="{ 'aria-label': 'Owner' }"
                      valueExpr="id"
                      displayExpr="name"
                      [label]="'ADMINISTRATION.TRAINING-CATEGORY.ASSOCIATED-TRAINING-GROUPS' | translate"
                      [dataSource]="trainingGroups"
                      labelMode="floating"
                      stylingMode="outlined"
                      [showClearButton]="true"
                      (onValueChanged)="onTrainingGroupsValueChanged($event)"
                    >
                      <div *dxTemplate="let data of 'content'">
                        <dx-tree-view
                          #trainingGroupsTree
                          [searchEnabled]="true"
                          [dataSource]="trainingGroups"
                          dataStructure="plain"
                          keyExpr="id"
                          selectionMode="multiple"
                          showCheckBoxesMode="normal"
                          [selectNodesRecursive]="false"
                          displayExpr="name"
                          [selectByClick]="true"
                          (onItemSelectionChanged)="
                            onTrainingGroupSelected($event)
                          "
                        ></dx-tree-view>
                      </div>
                    </dx-drop-down-box>
                  </div>

                  <div class="training-category-section-description">
                    <span class="training-category-section-description-dot">•</span>
                    {{ 'ADMINISTRATION.TRAINING-CATEGORY.ASSOCIATED-TRAINING-GROUPS-INFO' | translate }}
                  </div>

                  <div
                    class="associated-standard-category-container"
                    *ngIf="!formData.standardTrainingCategoryId"
                  >
                    <div class="associated-standard-category-selector">
                      <dx-drop-down-box
                        #associatedStandardCategoryDropDown
                        [value]="formData.associatedStandardTrainingCategoryId"
                        [dataSource]="standardTrainingCategories"
                        [label]="
                          ('ADMINISTRATION.TRAINING-CATEGORY.ASSOCIATED-STANDARD-CATEGORY' 
                            | translate) + ` (${ 'COMMON.OPTIONAL' | translate })`
                        "
                        displayExpr="name"
                        valueExpr="id"
                        [showClearButton]="true"
                        (onOpened)="openAssociatedStandardCategoryModal()"
                        (onValueChanged)="clearAssociatedStandardCategory($event)"
                      ></dx-drop-down-box>
                    </div>

                    <div class="training-category-section-description">
                      <span class="training-category-section-description-dot">•</span>
                      {{ 'ADMINISTRATION.TRAINING-CATEGORY.ASSOCIATED-STANDARD-CATEGORY-INFO' | translate }}
                    </div>
                  </div>
                </div>
              </div>
            </dxi-item>
            <dxi-item
              editorType="dxCheckBox"
              dataField="includeInLearningMatrix"
              [editorOptions]="{
                text: 'COMMON.FIELDS.INCLUDE-CATEGORY-IN-LEARNING-MATRIX' | translate,
              }"
            >
              <dxo-label [visible]="false"></dxo-label>
            </dxi-item>
          </dx-form>
        </app-panel>
      </div>
      <div class="col-md-12">
        <app-panel [title]="'ADMINISTRATION.EXTENDED-DESCRIPTION' | translate">
          <app-expandable-text-editor
            [(value)]="formData.descriptionExtended"
          ></app-expandable-text-editor>
          <div 
            *ngIf="userContext.canUseTextTemplates"
            class="text-template-container"
          >
            <app-text-template-selector
              [type]="descriptionTextTemplateType"
              [content]="formData.descriptionExtended"
              (contentChange)="onTemplateContentChanged($event)"
            ></app-text-template-selector>
          </div>
        </app-panel>
      </div>
      <div class="col-md-12" *ngIf="editingMode">
        <app-panel [title]="'ADMINISTRATION.UPLOAD-DOCUMENTS' | translate">
          <div class="row">
            <div class="col-md-12 col-lg-5">
              <app-panel class="image-panel">
                <div id="document-upload" class="uploader-container">
                  <div class="uploader-preview-container">
                    <img src="assets/img/upload.jpg" />
                    <span class="preview-title">{{
                      "COMMON.UPLOAD-DOCUMENT" | translate
                    }}</span>
                  </div>
                </div>
                <dx-file-uploader
                  #fileUploader
                  dialogTrigger="#document-upload"
                  dropZone="#document-upload"
                  [multiple]="false"
                  uploadMode="useForm"
                  [visible]="false"
                  (valueChange)="onDocumentSelected($event)"
                ></dx-file-uploader>
              </app-panel>
            </div>
            <div class="col-md-12 col-lg-7">
              <app-panel class="training-category-panel">
                <div class="files-title">
                  {{ "COMMON.FILES" | translate }} ({{
                    currentTrainingCategory && currentTrainingCategory!.files
                      ? currentTrainingCategory!.files!.length
                      : 0
                  }})
                </div>
                <div
                  class="full-height-list"
                  *ngIf="
                    currentTrainingCategory && currentTrainingCategory!.files
                  "
                >
                  <div class="list-wrapper">
                    <dx-list
                      [dataSource]="currentTrainingCategory!.files!"
                      class="striped-list"
                    >
                      <div *dxTemplate="let item of 'item'">
                        <div class="file">
                          <div class="file-name">
                            <div>{{ item.fileName }}</div>
                            <div class="file-url">
                              {{ item.fileUrl }}
                            </div>
                          </div>
                          <div
                            class="close-action"
                            (click)="onRemoveFileClicked(item)"
                          >
                            <i class="dx-icon-close"></i>
                          </div>
                        </div>
                      </div>
                    </dx-list>
                  </div>
                </div>
              </app-panel>
            </div>
          </div>
        </app-panel>
      </div>
    </div>
  </app-page>
</div>

<app-confirmation-dialog
  [height]="'auto'"
  [(showModal)]="showDeleteFileModal"
  (submit)="onRemoveFileConfirm()"
  [options]="modalConfirmationOptions"
></app-confirmation-dialog>

@if(showAssociatedStandardCategoryModal) {
  <app-standard-category-selector-modal
    [(showModal)]="showAssociatedStandardCategoryModal"
    [isAssociatedCategory]="true"
    [selectedCategoryId]="formData.associatedStandardTrainingCategoryId"
    [standardCategories]="standardTrainingCategories"
    (categorySelected)="onAssociatedStandardCategorySelected($event)"
  ></app-standard-category-selector-modal>
}

@if(showStandardCategoryModal) {
  <app-standard-category-selector-modal
    [(showModal)]="showStandardCategoryModal"
    [selectedCategoryId]="formData.standardTrainingCategoryId"
    [standardCategories]="standardTrainingCategories"
    (categorySelected)="onStandardCategorySelected($event)"
  ></app-standard-category-selector-modal>
}